var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineLantern5Nml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2078,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 396,
    width: 2078,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-347 -396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 396,
    width: 2078,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.77 820.581C1595.28 742.644 1937.56 954.83 2013.29 1294.51 2089.01 1634.2 1869.49 1972.74 1522.99 2050.68 1176.48 2128.62 834.193 1916.43 758.47 1576.75 682.81 1237.35 901.899 899.021 1248.03 820.748L1292.37 1018.52C1055.18 1072.37 904.76 1302.77 956.405 1533.13 1008.05 1763.49 1242.2 1906.59 1479.39 1852.74 1716.58 1798.89 1866.99 1568.49 1815.35 1338.13 1763.75 1107.96 1529.92 964.875 1292.87 1018.41Z",
    fill: "#FFEA01",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineLantern5Nml);
export default __webpack_public_path__ + "static/media/MarineLantern5NML.d2191b30dab1854d30840c818bd54b6a.svg";
export { ForwardRef as ReactComponent };